import { useEffect, useState } from 'react';

import { logger } from '~/utils/logger';

export const useDynamicallyLoadMockServiceIfEnabled = (): boolean => {
  const [isMockReady, setIsMockReady] = useState(!__ENABLE_MOCK_SERVICE__);

  useEffect(() => {
    if (!__ENABLE_MOCK_SERVICE__) return;

    let cancelled = false;

    try {
      const init = async () => {
        const { MockService } =
          await import('~/dev/utils/MockService/MockService');
        await MockService.initialize();

        if (!cancelled) {
          setIsMockReady(true);
        }
      };

      init();
    } catch (error) {
      logger.mockService('Error initializing mock service:', error);
      setIsMockReady(true);
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return isMockReady;
};
